<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <router-link class="navbar-brand" to="/">
        <img src="@/assets/images/logo_navbar.png" alt="logo">
      </router-link>

      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarContent"
        aria-controls="navbarContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 align-items-center" style="gap: 0.75rem;">

          <li class="nav-item" v-if="auth">
            <div class="nav-user">
              <div class="nav-user__avatar">
                <i class="pi pi-user"></i>
              </div>
              <span class="nav-user__name">لوحة التحكم</span>
            </div>
          </li>
          <li class="nav-item" v-if="auth">
            <button class="theme-toggle-btn" type="button" @click="toggleTheme" :title="isDark ? 'تفعيل الوضع الفاتح' : 'تفعيل الوضع الداكن'">
              <i :class="isDark ? 'pi pi-sun' : 'pi pi-moon'"></i>
            </button>
          </li>
          <li class="nav-item" v-if="auth">
            <router-link to="/payment-requests" class="nav-bell" title="طلبات الدفع المعلّقة">
              <i class="pi pi-bell"></i>
              <span v-if="pendingCount" class="nav-bell__badge">{{ pendingCount > 99 ? '99+' : pendingCount }}</span>
            </router-link>
          </li>
          <li class="nav-item" v-if="auth">
            <button class="nav-logout-btn" type="button" @click="logout">
              <i class="pi pi-sign-out"></i>
              <span>تسجيل خروج</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { usePaymentRequestStore } from '@/stores/usePaymentRequestStore.js';

export default {
  data() {
    return {
      auth: false,
    }
  },
  computed: {
    isDark() {
      return this.$store.getters["currentTheme"] === "dark";
    },
    pendingCount() {
      return usePaymentRequestStore().pendingCount;
    }
  },
  methods: {
    logout() {
      localStorage.removeItem("token");
      location.reload();
    },
    toggleTheme() {
      const next = this.isDark ? "light" : "dark";
      this.$store.dispatch("setTheme", next);
    }
  },
  created() {
    this.auth = this.$store.getters["isAuthenticated"];
    if (this.auth) {
      // Actionable admin notification count (pending payment requests).
      usePaymentRequestStore().fetchPendingCount().catch(() => {});
    }
  }
}
</script>

<style scoped>
.theme-toggle-btn {
  background: transparent;
  border: 1px solid var(--gold);
  color: var(--gold);
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  font-size: 1rem;
}
.theme-toggle-btn:hover {
  background: var(--gold);
  color: var(--btn-on-gold, #0F0F0F);
}
.nav-bell {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 8px;
  border: 1px solid var(--gold);
  color: var(--gold);
  text-decoration: none;
  transition: background 0.2s, color 0.2s;
}
.nav-bell:hover {
  background: var(--gold);
  color: var(--btn-on-gold, #0F0F0F);
}
.nav-bell__badge {
  position: absolute;
  top: -6px;
  inset-inline-end: -6px;
  background: #ef4444;
  color: #fff;
  font-size: 0.68rem;
  font-weight: 700;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
